import { SheetUtils } from '../../../utils/SheetUtils';

// { 0: { 0: [{}, {}, {}] } }
class CellIcon {
  constructor({
    xIconBuilder, data = {},
  } = {}) {
    this.xIconBuilder = xIconBuilder;
    this.data = data;
  }

  add(ri, ci, icon) {
    const { data } = this;
    if (data[ri] == null) {
      data[ri] = {};
    }
    if (data[ri][ci] == null) {
      data[ri][ci] = [];
    }
    data[ri][ci].push(this.xIconBuilder.build(icon));
  }

  getIcons(ri, ci) {
    const { data } = this;
    if (data[ri] == null) {
      return SheetUtils.Nul;
    }
    if (data[ri][ci] == null) {
      return SheetUtils.Nul;
    }
    const icons = data[ri][ci];
    if (icons.init) {
      return icons;
    }
    data[ri][ci] = icons.map((icon) => this.xIconBuilder.build(icon));
    data[ri][ci].init = true;
    return data[ri][ci];
  }

  remove(ri, ci, index) {
    const { data } = this;
    if (data[ri] == null) {
      return;
    }
    if (data[ri][ci] == null) {
      return;
    }
    const icons = data[ri][ci];
    if (index === -1) {
      delete data[ri][ci];
    } else {
      icons.splice(index, 1);
    }
  }
}

export {
  CellIcon,
};
